module.exports = __webpack_public_path__ + "static/heroslide-5-f2290b3d147a5c7ee56f23f1b5d3e4af.jpeg";